// extracted by mini-css-extract-plugin
export default {"container":"LabelledInput_container__aNjZx","label":"LabelledInput_label__QKMN3","asterisk":"LabelledInput_asterisk__hEBuO"};